import { PortfolioCapTable } from '~/components/ui/tables/ag/portfolioCapTable/portfolioCapTable';

type RoundSectionProps = {
  portfolioCompanyId: string;
};

export default function RoundSection({
  portfolioCompanyId,
}: RoundSectionProps) {
  return (
    <div
      className="flex flex-column mt-3 w-full p-3 h-30rem gray-border"
      style={{
        borderRadius: '8px',
      }}
    >
      <>
        <h3 className="w-full">Cap Table</h3>
        <PortfolioCapTable portfolioCompanyId={portfolioCompanyId} />
      </>
    </div>
  );
}
